import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=c6c3b066&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6c3b066')) {
      api.createRecord('c6c3b066', component.options)
    } else {
      api.reload('c6c3b066', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=c6c3b066&", function () {
      api.rerender('c6c3b066', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HMtB83I6YR7n/JS/comp/ImgFallback.vue"
export default component.exports